import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  PgProviderFeeHistoriesFindResponse,
  PgProviderFeesFindResponse,
  pgProviderFeeApi,
} from '../../../lib/api/pgProviderFee';

export const pgProviderFeeQuery = createQueryKeys('pgProviderFee', {
  list: () => ({
    queryKey: ['list'],
    queryFn: (): Promise<PgProviderFeesFindResponse> => pgProviderFeeApi.getFees(),
  }),
  histories: (limit: number) => ({
    queryKey: [limit],
    queryFn: (): Promise<PgProviderFeeHistoriesFindResponse> => pgProviderFeeApi.getHistories(limit),
  }),
});
